// extracted by mini-css-extract-plugin
module.exports = {"article":"styles_article__yE7iK","rich_article":"styles_rich_article__uBy_u"};